export const sortAttributes = (a, b) => {
    const sortOnA = a.sortGroup && a.sortGroup.attributeSortOrder ? a.sortGroup.attributeSortOrder : null;
    const sortOnB = b.sortGroup && b.sortGroup.attributeSortOrder ? b.sortGroup.attributeSortOrder : null;
    const sortedOrder = sortOnA === sortOnB ? 0 : sortOnA === null ? 1 : sortOnB === null ? -1 : sortOnA - sortOnB;

    return sortedOrder || a.name.localeCompare(b.name);
};

export const validateValueByType = (value, type) => {
    let isValid = true;
    switch (type) {
        case "Measurement":
            if (typeof value === "string" || !value.hasOwnProperty("value") || !value.hasOwnProperty("uom")) {
                isValid = false;
            }

            break;
        case "DropdownPickList":
            if (typeof value === "string" || !value.hasOwnProperty("value")) {
                isValid = false;
            }

            break;
        case "MeasurementList":
        case "Picklist":
        case "ImagePicklist":
        case "StringList":
        case "FeatureBullet":
        case "LinkList":
            if (typeof value === "string" || value.length < 0) {
                isValid = false;
            }

            break;
        case "EnergyPanel":
        case "LightingPanel":
        case "NutritionPanel":
        case "SupplementPanel":
        case "DrugPanel":
            if (typeof value === "string") {
                isValid = false;
            }

            break;
        default:
            break;
    }

    return isValid;
};

export const checkDataTypeAllowed = (type) => {
    switch (type) {
        case "PegMeasurement":
            return false;
        default:
            return true;
    }
};

export const valueAppendedOrReplacedByType = (type, newValue, oldValue) => {
    switch (type) {
        case "StringList":
            return [...oldValue, newValue];
        default:
            return newValue;
    }
};

export const sortByOrder = (a, b) => {
    return a.order - b.order;
};
